import React, { useMemo, useState } from 'react';

// MUI Core
import MuiDrawer from '@material-ui/core/Drawer';
import MuiList from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import MuiListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { styled } from '@material-ui/core/styles';
import styles from './sidenav.module.scss';
import { blockSellerList } from '../../utils/constants';

// MUI Icons
import RightArrow from '@material-ui/icons/ChevronRight';
import CallIcon from '@material-ui/icons/PhoneOutlined';
import EmailIcon from '@material-ui/icons/MailOutline';
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined';
// Router
import { Link as RouteLink, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { Context as AuthContext } from '../../Redux/context/AuthContext';

// Custom Components
import {
  navItems,
  SUPPORT_PHONE,
  SUPPORT_TIMEING,
  SUPPORT_AVAILBILITY,
  SUPPORT_EMAIL,
  PHONE_PREFIX,
  pilotNavItems,
} from './constant';
import breakpoints from '../../theme/breakpoints';
import colors from '../../theme/colors';
import { Box } from '../Layouts';
import { pilotSellers } from '../../utils/constants';
import TermsAndConditionPage from '../../pages/TermsAndCondition';
import FaqComponent from '../../pages/FAQ/faqComponent';
import Dialog from '../Dialog';

import getApobSupplierId from '../../utils/getApobSupplierId';
// import useAdmin from '../../hooks/useAdmin';

const Drawer = styled(MuiDrawer)(() => ({
  width: breakpoints.drawerWidth,
  flexShrink: 0,
  '& .MuiDrawer-paper': {
    marginTop: '80px',
    paddingBottom: '80px',
    zIndex: '1040',
    width: breakpoints.drawerWidth,
    boxSizing: 'border-box',
    height: 'calc(100% - 80px)',
  },
}));

export const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  paddingLeft: '20px',
}));

const List = styled(MuiList)(() => ({
  padding: '8px 0px 8px 8px',
}));

const ListItem = styled(MuiListItem)(({ active }) => ({
  borderRadius: '8px',
  marginBottom: '5px',
  transition: '0.3s ease-in',
  backgroundColor: active ? '#22C0E71A' : '',
  // color: active ? colors.primary : '',
  borderTopRightRadius: active ? '0px' : '',
  borderBottomRightRadius: active ? '0px' : '',
  borderRight: active ? '3px solid #22C0E7' : '',
  ':hover': {
    transition: '0.3s ease-out',
    backgroundColor: colors.gray,
    color: colors.themeLightBlue,
  },
}));

export const Link = styled(RouteLink)(() => ({
  color: 'inherit',
  textDecoration: 'none !important',
  '& :hover': {
    textDecoration: 'none',
  },
}));

const BottomSection = styled('div')(() => ({
  position: 'absolute',
  bottom: 0,
  width: '100%',
  minHeight: 90,
  background: '#E8FAFF',
}));

const Icon = styled(ListItemIcon)(() => ({
  color: 'inherit',
  fontSize: '20px',
  minWidth: '35px',
}));

const BadgeGroup = styled(Box)(({ badge }) => ({
  padding: 10,
  width: `100%`,
  backgroundColor: colors.primaryDark,
  marginBottom: 12,
  '&.arz__badge_border': {
    padding: 2,
    borderRadius: 4,
    margin: 0,
    background: colors.gradients[badge],
    '& > .badge-content': {
      padding: 4,
      width: `100%`,
      display: 'flex',
      alignItems: 'center',
      // justifyContent: 'space-around',
      border: `1.5px solid`,
      backgroundColor: colors.primaryDark,
      minHeight: 110,
    },
  },
}));

const Badge = styled(Box)(() => ({
  position: 'relative',
  '& > span': {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -40%)',
  },
}));

const Tier = styled(Box)(() => ({
  fontWeight: 600,
  textTransform: 'capitalize',
  fontSize: 18,
  marginLeft: 2,
  '& > .arz__tier_link': {
    margin: 0,
    color: colors.white,
    fontSize: 13.6,
    marginTop: 3,
    cursor: 'pointer',
    background: 'transparent',
  },
}));
const Anchor = styled('a')(() => ({
  color: 'inherit',
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'none',
  },
  '& span.MuiTypography-body1': {
    fontSize: 13,
  },
}));

const ContactUsContainer = styled('div')(() => ({
  fontSize: '14px',
  fontWeight: '500',
  lineHeight: '16px',
  padding: '8px 16px',
}));

const SideNav = ({ open, tier, onBadgeClick, toggleNav }) => {
  const { logout } = React.useContext(AuthContext);
  let location = useLocation();
  const [agreementOpen, setAgreementOpen] = useState(false);
  const [faqOpen, setFaqOpen] = useState(false);
  const userData = JSON.parse(localStorage.getItem('login_data'));
  const { APICredentials } = useSelector((state) => state.credentials);
  // const [isAdmin] = useAdmin();

  const [logoutPopup, setLogoutPopup] = useState(false);

  const endSession = async () => {
    await logout();
  };

  const handleDialogAction = (flag) => {
    if (flag) endSession();
    setLogoutPopup(false);
  };

  const { apobSupplierID } = getApobSupplierId();
  const SELLER_TYPE_PPOB = 'PPOB';
  // let navigationItems = !pilotSellers.includes(userData['phone_number']) ? navItems : pilotNavItems;

  const getNavigationItems = () => {
    // if (isAdmin) {
    //   return navItems.filter((item) => {
    //     return item.showAdmin;
    //   });
    // }
    if (userData?.user_id == apobSupplierID && userData?.falconBusinessType === SELLER_TYPE_PPOB) {
      return navItems.filter((item) => {
        return item.path !== '/grn';
      });
    } else {
      return navItems.filter((item) => {
        return item.path !== '/bulk-deals' && item.path !== '/reverse-auction';
      });
    }
  };

  let navigationItems = getNavigationItems();
  return (
    <Drawer variant="persistent" anchor="left" open={open}>
      {logoutPopup ? <Dialog open={logoutPopup} onAction={handleDialogAction} /> : null}
      {/* <DrawerHeader>
        <img src="/images/FalconLogo.svg" width="75px" height="auto" alt="Logo" />
      </DrawerHeader>*/}
      <Divider />
      {userData?.user_id == apobSupplierID && userData?.falconBusinessType === SELLER_TYPE_PPOB && (
        <BadgeGroup hidden={!tier}>
          <BadgeGroup badge={tier} className={'arz__badge_border'}>
            <Box className="badge-content">
              <Badge>
                <img src={`/images/badge/arzooo_icon_${tier}.png`} height={65} />
              </Badge>
              <Tier>
                <Tier className={styles[`arz__tier_${tier}`]}>Arzooo {tier}</Tier>
                <Tier
                  onClick={onBadgeClick}
                  className={'arz__tier_link'}
                  moenagage-id={JSON.stringify({
                    eventName: 'Home_page_Seller_policy_viewed',
                    eventDetails: 'Seller policy clicked and viewed',
                  })}
                >
                  More Details <RightArrow fontSize="inherit" />
                </Tier>
              </Tier>
            </Box>
          </BadgeGroup>
        </BadgeGroup>
      )}

      <List
        className={
          userData?.user_id == apobSupplierID && userData?.falconBusinessType === SELLER_TYPE_PPOB
            ? styles.sideNavContainer
            : styles.sideNavContainer_withoutTier
        }
      >
        {navigationItems?.map((item) => (
          <Link
            to={{
              pathname: item.path,
              state: { source: 'from side navbar' },
            }}
            key={`NavLink__${item.name}`}
            style={
              APICredentials.isSaved === 0 &&
              blockSellerList.includes(userData?.user_id) &&
              item.name !== 'IRN Addition'
                ? { pointerEvents: 'none' }
                : {}
            }
          >
            <ListItem
              button
              key={`ListItem__${item.name}`}
              active={location.pathname === item.path ? 1 : 0}
            >
              {item.icon ? (
                <Icon>
                  <img style={{ width: '25px' }} src={item.icon} />
                </Icon>
              ) : item.class ? (
                <Icon className={item.class} />
              ) : (
                <Icon>
                  <img
                    src={
                      location.pathname === item.path
                        ? `/images/${item.activeIcon}`
                        : `/images/${item.inactiveIcon}`
                    }
                    alt="Icon"
                    width="24px"
                    className="mr-2"
                    height="auto"
                  />
                </Icon>
              )}
              <ListItemText
                primary={item.name}
                style={
                  APICredentials.isSaved === 0 &&
                  blockSellerList.includes(userData?.user_id) &&
                  item.name !== 'IRN Addition'
                    ? { color: 'gray' }
                    : {}
                }
              />
              {item.new && (
                <div className="circle">
                  <div className="new">NEW</div>
                </div>
              )}
            </ListItem>
          </Link>
        ))}
        <div
          onClick={() => {
            setLogoutPopup(true);
          }}
        >
          <ListItem button key={`ListItem__Logout`} active={0}>
            <Icon>
              <img style={{ width: '25px' }} src="/images/Logout.svg" />
            </Icon>
            <ListItemText primary={'Logout'} />
          </ListItem>
        </div>
      </List>
      <BottomSection>
        <List>
          <ContactUsContainer>
            <span>
              <b>Contact Us</b>
            </span>
            <div className={`d-flex mt-2`}>
              <a href={`tel:${PHONE_PREFIX + SUPPORT_PHONE}`}>
                <img style={{ height: '20px' }} src="/images/Call.svg" />
              </a>
              <a href={`mailto:${SUPPORT_EMAIL}`}>
                <img style={{ height: '20px' }} className={`ml-4`} src="/images/Message.svg" />
              </a>
            </div>
          </ContactUsContainer>
          {/* <Anchor
            href={`tel:${PHONE_PREFIX + SUPPORT_PHONE}`}
            moenagage-id={JSON.stringify({
              eventName: 'Seller_Support_Call',
              eventSource: 'From side Nav bar',
            })}
          >
            <ListItem button alignItems="flex-start">
              <CallIcon className={styles.arz__seller_support_icon} />
              <span className="MuiTypography-body1">
                {PHONE_PREFIX} {''} {SUPPORT_PHONE}
                <sup>({SUPPORT_TIMEING})</sup>
                <div style={{ marginTop: -3 }}>
                  <small>({SUPPORT_AVAILBILITY})</small>
                </div>
              </span>
            </ListItem>
          </Anchor>
          <Anchor
            href={`mailto:${SUPPORT_EMAIL}`}
            moenagage-id={JSON.stringify({
              eventName: 'Seller_Support_Email',
              eventSource: 'From side Nav bar',
            })}
          >
            <ListItem button>
              <EmailIcon className={styles.arz__seller_support_icon} />
              <ListItemText primary={SUPPORT_EMAIL} />
            </ListItem>
          </Anchor> */}
          {/* <Anchor>
            <ListItem
              button
              onClick={() => {
                setFaqOpen(true);
                setAgreementOpen(false);
                toggleNav(false);
              }}
            >
              <AssignmentOutlinedIcon className={styles.arz__seller_support_icon} />
              <ListItemText
                primary={'FAQs'}
                moenagage-id={JSON.stringify({
                  eventName: 'Seller_support_viewed',
                  eventDetails: 'FAQ clicked and viewed',
                })}
              />
            </ListItem>
          </Anchor> */}
          <Anchor>
            <ListItem
              button
              onClick={() => {
                setAgreementOpen(true);
                setFaqOpen(false);
                toggleNav(false);
              }}
            >
              <AssignmentOutlinedIcon className={styles.arz__seller_support_icon} />
              <ListItemText
                primary={'Terms and Conditions'}
                moenagage-id={JSON.stringify({
                  eventName: 'TnC_viewed',
                  eventDetails: 'TnC clicked and viewed',
                })}
              />
            </ListItem>
          </Anchor>
        </List>
      </BottomSection>
      {agreementOpen && (
        <TermsAndConditionPage
          agreementOpen={agreementOpen}
          closeAgreementOpen={setAgreementOpen}
          showTerms={true}
          showWorkingHours={true}
          disableButtons={true}
          showClose={true}
          isTnC={true}
          tier={tier}
          toggleNav={toggleNav}
        />
      )}
      {faqOpen && (
        <FaqComponent
          faqOpen={faqOpen}
          showFaq={true}
          showClose={true}
          closeFaqOpen={setFaqOpen}
          toggleNav={toggleNav}
        />
      )}
    </Drawer>
  );
};

export default React.memo(SideNav);
